/* template */
<template><es-layout :layout="(['header','footer'])" :click-left="(goback)" class="es-add" :custom-class='["contact-add-custom-class"].join(" ")'><div slot="header" class="page-header"><es-navbar custom-class="es-add__navbar" title="注册12306账号" :leftArrow="(false)" class="es-add__navbar"><div slot="left" v-if="(!isHideLeftArrow)"><es-icon size="24" color="#333333" name="angle-left"></es-icon></div></es-navbar></div><register-content ref="__mpx_ref_contentRef__" :isAgree="(isAgree)"/><div class="bottom"><div class="tips es-rm-agree-box"><es-shake :shake="(shake)"><div class="es-rm-agreement"><es-checkbox-group :value="checkboxValue" mpxModelEvent="input" @mpxModel='__model("checkboxValue", $event, ["value"], undefined)' direction="row"><es-checkbox label-position="right" name="1" shap="square" :iconSize="(16)" :icon-style="({borderRadius: '4px'})" :useIconSlot="(true)"><mpx-image mode="aspectFit" slot="icon" src="https://pt-starimg.didistatic.com/static/starimg/img/d6u1QeWbMP1646634186170.png" class="es-zdy-icon" v-if="(isAgree)"></mpx-image></es-checkbox><div class="es-rm-checkbox">我们会将您填写的上述信息提供给青岛景行科技有限公司用于注册12306账号，我们不会存储您的上述信息，您应遵守<mpx-view view @tap="goto('a')" class="span">《服务协议》</mpx-view><mpx-view view @tap="goto('b')" class="span">《个人信息处理授权协议》</mpx-view></div></es-checkbox-group></div></es-shake></div><div class="footer"><mpx-view @tap="save" class="submit">下一步</mpx-view></div></div></es-layout></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m1f7e0f3c"}'>
  @import '~@/mixins/stylus/color.styl'
  +b('add')
    background #f0f1f4
    .page-header
      background #ffffff
    /deep/ .es-main
      background-color #f0f1f4
      margin-bottom calc(constant(safe-area-inset-bottom) + 150px)
      margin-bottom calc(env(safe-area-inset-bottom) + 150px)
    /deep/ .es-toast
      background-color #000000
      padding 12px 24px
    /deep/ .es-card__body
      padding 0 12px !important
    /deep/ .es-icon-angle-right
      font-size 20px !important
      color #999999 !important
    +e('navbar')
      background-color #ffffff
      height 44px !important
      z-index auto !important
      font-size 18px
      /deep/ .es-navbar
        height 60px
      /deep/ .es-navbar__right
        width 28px
      /deep/ .es-navbar__title
        font-size 18px
    +e('save')
      border-radius 8px !important
      font-size 16px !important
      /deep/ button
        border-radius 8px
    +e('footer')
      width 100%
      padding 16px
      background-color #ffffff
      box-shadow 0 -4px 20px 0 rgba(0, 0, 0, 0.04)
      // z-index 1

  .tips
    background linear-gradient(270deg, #FEFEFE 0%, #EDF4FF 100%)
  .es-rm-agree-box
    display flex
    justify-content space-between
    padding 8px 16px 
  .es-rm-checkbox
    font-size 12px
    color $train-color-999
    margin-left -5px
    flex 1
    .span 
      display inline
      color #1473FF

  .es-rm-navigator
    font-size 12px !important
    line-height 20px
    display block
    color $train-color-theme-blue
    margin-top 1px
    text-decoration none
    letter-spacing -1px
  .es-rm-navigator-hover
    color $train-color-theme-blue
  .es-rm-agreement
    /deep/ .es-checkbox-group--row 
      align-items flex-start
    /deep/ .es-checkbox
      margin-top 1px
  .bottom
    position fixed
    bottom 0px 
    background #ffffff
  .footer
    width 100%
    background #FFFFFF
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    .submit
      margin 16px
      height 48px
      border-radius 8px
      background #1473FF
      font-family PingFangSC-Medium
      font-size 16px
      font-weight normal
      line-height 19px
      letter-spacing: 0px
      color #FFFFFF
      display flex
      align-items center
      justify-content center

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1f7e0f3c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./register.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./register.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m1f7e0f3c"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-checkbox':getComponent(require("../../es-mpx-ui/lib/checkbox/index.mpx?isComponent&outputPath=components%2Findex8e1a7e44%2Findex")),'register-content':getComponent(require("./components/register/index.mpx?isComponent&outputPath=components%2Findex0200f898%2Findex")),'es-shake':getComponent(require("../../components/transition-shake/index.mpx?isComponent&outputPath=components%2Findex13bbb724%2Findex")),'es-checkbox-group':getComponent(require("../../es-mpx-ui/lib/checkbox-group/index.mpx?isComponent&outputPath=components%2Findex5f7ef460%2Findex")),'es-layout':getComponent(require("../../es-mpx-ui/lib/layout/index.mpx?isComponent&outputPath=components%2Findex2146c876%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
